import React from 'react';
import { Form } from 'react-form';

import { Input } from '../../../components/Form';
import { required } from '../../../utils/form-validation';

import styles from '../nuoV2.scss';

const TennisAustraliaForm = props => {
    const { handleSubmit } = props;

    return (
        <div className={styles.page}>
            <Form onSubmit={values => handleSubmit(values)}>
                {({ submitForm }) => {
                    return (
                        <form onSubmit={submitForm} id="OnboardingSurveyForm" data-testid="nuo-v2.tennis-australia-form.form">
                            <div className="row">
                                <div className="col-12 mb16">
                                    <label className={'fw500 mb0'} data-testid="nuo-v2.tennis-australia-form.tennis-id-label">
                                        Please enter your Tennis ID *
                                    </label>
                                </div>
                                <div className="col-12">
                                    <div className={styles.input}>
                                        <Input
                                            id="tennisConnectId"
                                            field="tennisConnectId"
                                            validate={required}
                                            themeV3
                                            data-testid="nuo-v2.tennis-australia-form.tennis-id-input"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className={`col-12 text-center`}>
                                    <div className={styles.submit}>
                                        <button type="submit" className={`btn btn-primary text-uppercase`} data-testid="nuo-v2.tennis-australia-form.submit-btn">
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    );
                }}
            </Form>
        </div>
    );
};

export default TennisAustraliaForm;
